import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.onFormSuccess
      }
    }), h("component-form-2", {
      "ref": "form2",
      "on": {
        "success": this.onFormSuccess
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'PAY_SET_ALL',
        delete: 'ROLEPAY_SET_DELETE'
      },
      permission: {
        query: 'system:payset:query',
        add: 'system:payset:add',
        edit: 'system:payset:edit',
        remove: 'system:payset:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: 'id',
        minWidth: '100px'
      }, {
        prop: 'market_id',
        label: '运营商',
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "form_market_id",
              "value": row.market_id,
              "custom": true
            }
          });
        }
      }, {
        prop: 'pay_api_key',
        label: '密钥',
        minWidth: '100px'
      }, {
        prop: 'currency',
        label: '货币类型',
        minWidth: '100px'
      }, {
        prop: 'ctime ',
        label: '创建时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'utime',
        label: '更新时间',
        width: '200px',
        formatter: function formatter(row) {
          return utils.time.format1(row.utime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        // setting.sortable = 'custom'
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref2) {
        var row = _ref2.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          label: '修改',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          label: '删除',
          type: 'danger',
          confirm: "\u786E\u5B9A\u5220\u9664 [ ".concat(row.market_id, " ] \u5417"),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        default: '',
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_market_id",
              "filterable": true,
              "clearable": true,
              "custom": true
            },
            "model": {
              value: _this3.search.form.model.market_id,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_id", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,user_name',
        path: 'list',
        label: 'market_info',
        value: 'id'
      });
    },
    onFormSuccess: function onFormSuccess() {
      this.$store.dispatch('d2admin/permission/load', {
        focus: true
      });
      this.research();
    }
  }
};